import styled, { css, DefaultTheme } from "styled-components";
import { lightTheme } from "styles/themes/light";

type Breakpoint = keyof typeof lightTheme.breakpoints;

type MediaMatchProps = {
  lessThan?: Breakpoint;
  greaterThan?: Breakpoint;
};

const modifiers = {
  lessThan: (theme: DefaultTheme, size: Breakpoint) => css`
    @media (max-width: ${theme.breakpoints[size]}) {
      display: initial !important;
    }
  `,
  greaterThan: (theme: DefaultTheme, size: Breakpoint) => css`
    @media (min-width: ${theme.breakpoints[size]}) {
      display: initial !important;
    }
  `,
};

export const MediaMatch = styled.div<MediaMatchProps>`
  ${({ theme, lessThan, greaterThan }) => css`
    display: none !important;
    ${!!lessThan && modifiers.lessThan(theme, lessThan)}
    ${!!greaterThan && modifiers.greaterThan(theme, greaterThan)}
  `}
`;
